import React from 'react';

import { defaultPromoCode } from '../../../../constants/home';
import { isAgent } from '../../../../helpers';
import { onlinePromoEvent, usePub } from '../../../../utils/pubSub';
import Banner from '../../../Banner/Banner';

const pubPromo = usePub();

const PromocodeBanner = () => (
  <div>
    <p>
      {/* eslint-disable-next-line flowtype/no-types-missing-file-annotation */}
      Click the promocode <button className={`copy_text_button`} onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                                    event.preventDefault();
                                    pubPromo(onlinePromoEvent);
                                  }}>
      <strong>{defaultPromoCode}</strong></button> to get a{' '}
      <strong>10% discount</strong> off Home Insurance exclusively online.
    </p>
    <h2>Features:</h2>
    <ul>
      <li>Free instalment plan</li>
      <li>Comprehensive cover</li>
      <li>Tailored options</li>
    </ul>
  </div>
);

const AgentScriptingBanner = () => (
  <div>
    <h2>Existing quotes from online - Terms and Conditions</h2>
    <p>
      Can you please confirm that you have read and accepted our Terms and
      Conditions?
    </p>
    <h2>Data Security</h2>
    <p>Must answer 2 Correct to pass verification:</p>
    <ol>
      <li>Date of Birth – Mandatory.</li>
      <li>Address of the property to be insured.</li>
      <li>Address of the correspondence address.</li>
    </ol>
  </div>
);

export const AboutYouBanner = () => (
  <Banner>
    <PromocodeBanner />
    {isAgent() && <AgentScriptingBanner />}
  </Banner>
);
